(() => {
  const key = 'mooli-cart-origin';
  const config = document.getElementById('mooli-cart-navigation');
  if (!config) return;
  const settings = JSON.parse(config.textContent);
  const valid = value => value === 'pillow' || value === 'monsters';
  let origin = settings.current;
  try {
    if (valid(origin)) sessionStorage.setItem(key, origin);
    else origin = sessionStorage.getItem(key);
  } catch (_) {}
  if (valid(settings.current)) window.addEventListener('pageshow', () => {
    try { sessionStorage.setItem(key, settings.current); } catch (_) {}
  });
  if (!settings.cart) return;
  if (!valid(origin) && document.referrer) {
    try {
      const previous = new URL(document.referrer);
      if (previous.origin === location.origin) {
        if (/\/products\/mooli-travel-pillow\/?$/.test(previous.pathname)) origin = 'pillow';
        else if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/?)?$/i.test(previous.pathname) ||
          /\/products\/little-(?:monster-hooded-fleece-romper|dino-hooded-romper|unicorn-hooded-romper)\/?$/.test(previous.pathname)) origin = 'monsters';
      }
    } catch (_) {}
  }
  const destination = origin === 'pillow' ? settings.pillow : settings.monsters;
  function updateLinks() {
    document.querySelectorAll('.lr-bag-title > a, .lr-bag-empty > a, .lr-header .lr-brand, .lr-header nav a, .lr-footer .lr-brand, .lr-footer nav a').forEach(link => {
      const href = new URL(link.href, location.origin);
      if (link.matches('.lr-bag-title > a, .lr-bag-empty > a, .lr-brand') ||
        href.hash === '#lr-product') link.href = destination;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateLinks, {once:true});
  else updateLinks();
  window.addEventListener('pageshow', updateLinks);
  document.addEventListener('shopify:section:load', updateLinks);
})();